<script setup>
import { ref, onMounted } from "vue";
import LoteTerminos from "./LotePestanias/LoteTerminos.vue";
import LoteUbicacion from "./LotePestanias/LoteUbicacion.vue";

const props = defineProps({
  loteStore: Object, 
  usuarioStore: Object,
});

const loteStore = props.loteStore;

// Reactividad
const seccionActual = ref("ubicacion");
const isLoading = ref(true); 


function setSeccionActual(seccion) {
  seccionActual.value = seccion;
}


onMounted(() => {

  setTimeout(() => {
    isLoading.value = false; 
  }, 1000);
});


const secciones = [
  { slug: "ubicacion", texto: "Ubicación" },
  { slug: "terminos", texto: "Términos y Condiciones" },
];
</script>

<template>
  <div class="d-flex justify-content-start gap-2 mb-4">
    <button
      v-for="seccion in secciones"
      :key="seccion.slug"
      class="btn btn-light"
      :class="{ 'text-primary': seccionActual === seccion.slug }"
      @click="setSeccionActual(seccion.slug)"
      :aria-selected="seccionActual === seccion.slug"
    >
      {{ seccion.texto }}
    </button>
  </div>

  <div v-if="isLoading" class="text-center mt-3">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
    <p>Cargando contenido, por favor espere...</p>
  </div>

  <div v-else class="card">
    <LoteTerminos
      v-if="seccionActual === 'terminos'"
      :loteStore="loteStore" :usuarioStore="props.usuarioStore"
    />
    <LoteUbicacion
      v-if="seccionActual === 'ubicacion'"
      :loteStore="loteStore"
    />
  </div>
</template>

<style>
.btn-light.active,
.btn-light:active,
.btn-light[aria-selected="true"] {
  background-color: #fff !important;
  color: var(--bs-primary) !important;
  border-color: var(--bs-primary) !important;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style>
